export const SET_LOADING = 'SET_LOADING';
export const SET_USER_LOGIN = 'SET_USER_LOGIN';
export const SET_GLOBAL_DATA = 'SET_GLOBAL_DATA';
export const SET_MENU_VOCABULARIES = 'SET_MENU_VOCABULARIES';
